import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import Layout from './components/common/Layout';
import DashboardPage from './pages/DashboardPage';
import SearchPage from './pages/SearchPage';
import PaymentDetailPage from './pages/PaymentDetailPage';
import NotFoundPage from './pages/NotFoundPage';
import { AuthService } from './services/ipaService';
import './App.css';

function App() {
  const [initialized, setInitialized] = useState(false);
  const [initializationError, setInitializationError] = useState<string | null>(null);

  useEffect(() => {
    console.log('App component mounted, initializing auth');
    
    // Initialize the IPA SDK
    const authService = AuthService.getInstance();
    
    // Add token listener
    authService.addTokenListener(token => {
      console.log('Token listener triggered:', token ? 'Token received' : 'No token');
      if (token) {
        setInitialized(true);
      }
    });
    
    // Handle initialization timeout
    const timeoutId = setTimeout(() => {
      if (!initialized) {
        console.log('Initialization timeout reached');
        setInitializationError('Authentication failed. The IPA SDK could not initialize.');
      }
    }, 10000);
    
    return () => {
      clearTimeout(timeoutId);
    };
  }, [initialized]);

  if (!initialized) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div style={{ padding: '40px', textAlign: 'center', maxWidth: '600px', margin: '0 auto' }}>
          <h2>Initializing IPA SDK...</h2>
          
          {initializationError && (
            <div style={{ 
              padding: '15px', 
              margin: '20px 0', 
              backgroundColor: '#f8d7da', 
              color: '#721c24',
              borderRadius: '5px',
              textAlign: 'left'
            }}>
              <strong>Error:</strong> {initializationError}
            </div>
          )}
          
          <div style={{ 
            marginTop: '30px', 
            padding: '15px', 
            backgroundColor: '#f8f9fa', 
            borderRadius: '5px',
            textAlign: 'left',
            fontSize: '14px'
          }}>
            <p><strong>Troubleshooting:</strong></p>
            <ol>
              <li>Check that the worker.js file is correctly copied to the public folder</li>
              <li>Verify that your App ID is correct (currently using: b8e7aeb2-03b9-4a21-935c-52d9b4b6aaeb)</li>
              <li>Check browser console for any errors</li>
              <li>Ensure you have network connectivity to the authentication server</li>
            </ol>
          </div>
        </div>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/payment/:paymentId" element={<PaymentDetailPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
}

export default App; 